import { FC, Suspense } from 'react';

import { CURRENCIES } from '@savgroup-front-common/constants';
import { Heading } from '@savgroup-front-common/core/atoms/Heading';
import { Skeleton } from '@savgroup-front-common/core/atoms/Skeleton';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { useRoutedStepsOrchestratorContext } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.context';
import { MyAccountIcon } from '@savgroup-front-common/core/protons/IconsNewDesign/MyAccount.icon';
import { rem } from '@savgroup-front-common/primitive/helpers/units';
import { ICONS_TYPE } from '@savgroup-front-common/types/Icon';

import { Payment } from '../../../../components/Payments/Payment';
import { IrshStepValues } from '../../IrshPages.types';
import { $HeadingIcon } from '../NewClaimGroupConfirmationPage.styles';

import { ClaimGroupConfirmationCashRegisterPayment } from './ClaimGroupConfirmationCashRegisterPayment/ClaimGroupConfirmationCashRegisterPayment';
import { usePaymentCard } from './hooks/usePaymentCard';
import messages from './messages';

interface PaymentCardProps {
  sellerId: string;
  onSubmitSuccess: () => Promise<void>;
  isFormCompleted?: boolean;
}

const PaymentCard: FC<PaymentCardProps> = ({
  sellerId,
  onSubmitSuccess,
  isFormCompleted = true,
}) => {
  const { paymentUrl, invoice } = usePaymentCard({ sellerId });

  const { values } = useRoutedStepsOrchestratorContext<IrshStepValues>();

  const claimGroupId = values?.claimGroupId;

  return (
    <Suspense fallback={<Skeleton width="100%" height={rem(280)} />}>
      <div>
        <Heading level={3}>
          <$HeadingIcon>
            <MyAccountIcon icon={ICONS_TYPE.CART_ICON} />
          </$HeadingIcon>
          <SafeFormattedMessageWithoutSpread message={messages.paymentTitle} />
        </Heading>

        {paymentUrl && claimGroupId && invoice && (
          <ClaimGroupConfirmationCashRegisterPayment
            paymentUrl={paymentUrl}
            claimGroupId={claimGroupId}
            invoice={{
              id: invoice.id,
              priceWithTax: invoice.priceWithTax,
              currencyTrigram:
                invoice.item?.at(0)?.currencyCode ?? CURRENCIES.EUR,
            }}
            isFormCompleted={isFormCompleted}
          />
        )}

        {!paymentUrl && invoice && claimGroupId && (
          <Payment
            invoice={{
              id: invoice.id,
              priceWithTax: invoice.priceWithTax,
              currencyTrigram:
                invoice.item?.at(0)?.currencyCode ?? CURRENCIES.EUR,
            }}
            onSubmitSuccess={onSubmitSuccess}
            isFormCompleted={isFormCompleted}
            claimGroupId={claimGroupId}
          />
        )}
      </div>
    </Suspense>
  );
};

export default PaymentCard;
